export default __webpack_public_path__ + "static/media/message-blue-success.0b067278.svg";